import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseTileData } from '../base-tile/base-tile.component';
import { ViewAsService } from '../../services/view-as.service';
import { map } from 'rxjs/operators';
import { NgxMaskService } from 'ngx-mask';
import { EoITileData } from '../../models/eoi-list.model';

@Component({
  selector: 'app-eoi-tile',
  templateUrl: './eoi-tile.component.html',
  styleUrls: ['./eoi-tile.component.scss']
})
export class EoITileComponent implements OnInit {

  @Input() document!: EoITileData;
  @Input() showOpenedLabel = false;

  @Output() tileClick = new EventEmitter<EoITileData>();

  data!: BaseTileData;

  showCreator$ = this.viewAsService.selectedUsers$.pipe(map(users => users === 'All' || users.length > 1));

  refreshData() {
    const phoneNumber = this.maskService.applyMask(this.document.phoneNumber, '(000) 000-0000');
    this.data = {
      title: this.document.firstName + ' ' + this.document.lastName,
      subtitle: phoneNumber,
      description: this.document.jobType
    };
  }

  constructor(
    private maskService: NgxMaskService,
    private viewAsService: ViewAsService
  ) {}
  
  ngOnInit() {
    this.refreshData();
  }
}
